
// @ts-nocheck
import locale__builds_vozilo_vozilo_web_lang_hr_json from "../lang/hr.json";
import locale__builds_vozilo_vozilo_web_lang_en_json from "../lang/en.json";


export const localeCodes =  [
  "hr",
  "en"
]

export const localeLoaders = {
  "hr": [{ key: "../lang/hr.json", load: () => Promise.resolve(locale__builds_vozilo_vozilo_web_lang_hr_json), cache: false }],
  "en": [{ key: "../lang/en.json", load: () => Promise.resolve(locale__builds_vozilo_vozilo_web_lang_en_json), cache: false }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "jsTsFormatResource": true
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "hr",
      "files": [
        "lang/hr.json"
      ]
    },
    {
      "code": "en",
      "files": [
        "lang/en.json"
      ]
    }
  ],
  "defaultLocale": "hr",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "lang",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "fallbackLocale": {
    "hr-HR": [
      "hr"
    ]
  },
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "hr",
    "files": [
      {
        "path": "lang/hr.json",
        "cache": false
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "lang/en.json",
        "cache": false
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
